import { TrackingDataV2 } from '@oneaudi/audi-tracking-service';
import { AdditionalObjects, EventAttributes, EventInfo, PageUpdateObject } from '~/app/tracking/feld-m-types';

export abstract class BaseEvent {
	private readonly eventInfo: EventInfo;

	private readonly attributes?: Partial<EventAttributes>;

	private readonly additionalObjects?: AdditionalObjects;

	private readonly updatePageInfo?: PageUpdateObject;

	constructor({
		eventInfo,
		attributes,
		additionalObjects,
		updatePageInfo,
	}: {
		eventInfo: EventInfo;
		attributes?: Partial<EventAttributes>;
		additionalObjects?: AdditionalObjects;
		updatePageInfo?: PageUpdateObject;
	}) {
		this.eventInfo = eventInfo;
		this.attributes = attributes;
		this.additionalObjects = additionalObjects;
		this.updatePageInfo = updatePageInfo;
	}

	serialize(): TrackingDataV2 {
		return {
			event: {
				eventInfo: this.eventInfo,
				attributes: {
					componentName: 'configurator',
					label: '',
					clickID: '',
					targetURL: '',
					elementName: '',
					value: '',
					pos: '',
					...this.attributes,
				},
			},
			...(this.additionalObjects ? { componentUpdate: this.additionalObjects } : {}),
			...(this.updatePageInfo ? { pageUpdate: this.updatePageInfo } : {}),
		};
	}
}
